var _excluded = ["className", "sort", "onSort", "showClearAll", "renderPanelItem", "disableAnimation", "panelHeight", "fieldMark"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useEffect } from 'react';
import { useRefCallback, useForceUpdate } from '@okee-uikit/react-hooks';
import { classnames, format } from '@okee-uikit/react-utils';
import { useLocale, usePrefixCls, useDirection } from '@okee-uikit/react-config';
import { TreeMapState, useCascader } from '../../../hooks/cascader';
import { ListViewer } from '../../list-viewer';
export function CascaderViewer(props) {
  var className = props.className,
      _props$sort = props.sort,
      sort = _props$sort === void 0 ? false : _props$sort,
      onSort = props.onSort,
      showClearAll = props.showClearAll,
      renderPanelItem = props.renderPanelItem,
      _props$disableAnimati = props.disableAnimation,
      disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati,
      panelHeight = props.panelHeight,
      fieldMark = props.fieldMark,
      extra = _objectWithoutProperties(props, _excluded);

  var direction = useDirection();
  var cascader = useCascader();
  var update = useForceUpdate();
  var select = useLocale('select.selected');
  var selectCount = useLocale('select.selected-count');
  var empty = useLocale('cascader.empty');
  var onSortCallback = useRefCallback(onSort);
  var displayInfo = cascader.getDisplayInfo().map(function (item) {
    var id = item.id,
        label = item.label,
        disabled = item.disabled,
        readonly = item.readonly;
    return {
      label: label,
      value: id,
      disabled: disabled,
      readonly: readonly
    };
  });
  var cls = classnames(usePrefixCls('cascader-viewer', {
    rtl: direction === 'rtl'
  }), className);
  var handleDelete = useCallback(function (item) {
    if (cascader.multiple) {
      cascader.setItemState(item.value, TreeMapState.UNSELECTED);
      return;
    }

    cascader.resetValue();
  }, []);
  var handleClearAll = useCallback(function () {
    cascader.clearSelected();
  }, []);
  var handleSort = useCallback(function (list) {
    var infos = list.map(function (item) {
      return cascader.getItemInfo(item.value);
    }).filter(function (item) {
      return !!item;
    });
    var value = infos.map(function (item) {
      return item.value;
    });
    onSortCallback(value, infos);
  }, []);
  var getItemKey = useCallback(function (item) {
    return item.value;
  }, []);
  var listViewerTitle = cascader.multiple ? format(selectCount, {
    count: displayInfo.length
  }) : select;
  var updateCallBack = useCallback(function () {
    !fieldMark && update();
  }, [fieldMark, update]);
  useEffect(function () {
    cascader.addListener('value-change', updateCallBack);
    cascader.addListener('data-loading', updateCallBack);
    return function () {
      cascader.removeListener('data-loading', updateCallBack);
      cascader.removeListener('value-change', updateCallBack);
    };
  }, []);
  return React.createElement(ListViewer, _objectSpread(_objectSpread({}, extra), {}, {
    getItemKey: getItemKey,
    disableAnimation: disableAnimation,
    showClearAll: showClearAll,
    className: cls,
    title: listViewerTitle,
    value: displayInfo,
    onDelete: handleDelete,
    onClearAll: handleClearAll,
    renderPanelItem: renderPanelItem,
    listViewerHeight: panelHeight,
    onSort: handleSort,
    emptyText: empty,
    sort: sort
  }));
}